// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoWithButton_container__ZFgDR","title":"InfoWithButton_title__DMrPa","description":"InfoWithButton_description__VcfMS","button":"InfoWithButton_button__KMPYp"};